import Icon from '@ant-design/icons';
import React from 'react';

const BusinesSvg = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.333 5.938a1.5 1.5 0 011.5-1.5h9.857a1.5 1.5 0 011.5 1.5v6.429a1.5 1.5 0 01-1.5 1.5H2.834a1.5 1.5 0 01-1.5-1.5V5.938z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.905 7.438h7.714M3.905 10.867h7.714"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M9.672 2.452a.857.857 0 00-.814-.585H6.665a.857.857 0 00-.813.585L5.19 4.438h5.143l-.661-1.986z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.048 4.438v-.857M12.476 4.438v-.857"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BusinessIcon = (props: any) => <Icon component={BusinesSvg} {...props} />;

export default BusinessIcon;
